import { IHeroIcons } from '@shared/components/ui/hero-icons';

export interface IBreadcrumbRoute {
  label: string;
  url: string;
  favorite?: boolean;
  canFavorite?: boolean;
}

export interface IBreadcrumbWidget {
  iconName?: IHeroIcons['iconName'];
  flatIcon?: string;
  text?: string;
  size: number;
  id: string;
  timeStamp?: string;
  type?: 'dropdown' | 'button';
  css?: string;
  iconCss?: string;
  iconNameTouched?: IHeroIcons['iconName'];
  tooltip?: {
    text: string;
  }
}

export const breadcrumbHiddenRoutes = [
  'person/',
  'visitor/',
  'user/',
];
